<template>
    <div class="container public-view">

        <div class="row form-group" v-if="multipleResults">

            <div class="col-12">  <h1 class="public-subhead">Please verify participant information</h1>
                <label>Multiple results found, please verify caller identity and select one participant to continue:</label>
                <ul style="list-style-type: none; padding-left: 0;">
                    <li v-for="p in participants" :key="p.participantId">
                        <a href="#" @click="pickParticipant(p)" class="list-group-item list-group-item-action">
                            <div class="d-flex w-100 justify-content-between">
                                <h5 class="mb-1">{{ p.firstName }} {{p.lastName}}</h5>
                             </div>
                            <small>Employer: {{p.employerName}} {{p.amfCode}}</small><br>
                            <small>Email: {{ p.email }}</small><br>
                            <small>Address: {{p.address1}}<span v-if="p.address2"> {{p.address2}}</span>, {{p.city}}, {{p.state}} {{p.zip}}</small>

                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="noResult">
              <h1 class="public-subhead">Please verify participant information</h1>
                <label>No participant or dependent found, please verify caller identity and search participant to continue.</label>
        </div>
    </div>

</template>

<script>
import { romeApi } from '../framework';

export default {
     data() {
        return {
            participants:[],
            isLoaded: false,
        }
    },
    computed: {
        ssn()
        {
            return this.$route.params.ssn;
        },
        multipleResults()
        {
            return this.isLoaded && this.participants.length > 1;
        },
        noResult()
        {
            return this.isLoaded && this.participants.length == 0;
        }
    },
    methods: { 
        async load() {
            this.isLoaded = false;
            this.participants = [];
            const r = this.$route;
            var ssn = r.params.ssn;
            this.participants = await romeApi.get(`/system/search?text=${ssn}&searchParticipants=true`);   
            
            this.isLoaded = true;

            if(this.participants.length == 1) this.$router.push(`/participant/${this.participants[0].participantId}/general`);     
        },
        pickParticipant(participant)
        {
                var participantId = participant.participantId || participant.parentId;

                this.$router.push(`/participant/${participantId}/general`);                   
        }   
    },   
    watch:{
        ssn: {
            handler: function(v) {
                if(v) {
                    this.load();
                }
            },
            immediate: true
        }
    } 
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/framework/AmazonIvr.vue